import { Box, Tooltip, Typography } from "@mui/material";
import { GRID_BORDER, type RunSection } from "../../utils/dayHourGrid";
import { sectionTooltip } from "./sectionTooltip";
import { tooltipSlotProps } from "./tooltipSlotProps";

type Props = {
	block: RunSection;
	height: number;
};

/** a Holiday/Downtime covering the whole day takes over the row */
export const FullDayBlock = ({ block, height }: Props) => (
	<Tooltip arrow slotProps={tooltipSlotProps} title={sectionTooltip(block)}>
		<Box
			sx={{
				gridColumn: "2 / -1",
				minHeight: height,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				backgroundColor: block.colors.bg,
				borderBottom: GRID_BORDER,
			}}
		>
			<Typography
				variant="caption"
				sx={{
					fontWeight: 700,
					color: block.colors.color,
					letterSpacing: "0.04em",
				}}
			>
				{block.label}
			</Typography>
		</Box>
	</Tooltip>
);
